function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 12.7969,
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254",
    d: "M28.6604 58.5054C33.2701 59.3266 37.6727 56.2554 38.4939 51.6458L38.6902 50.5434L30.3437 49.0565L28.6604 58.5054Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254_2",
    d: "M17.064 41.6957C17.064 37.9852 20.0719 34.9773 23.7823 34.9773H34.1265L33.1605 41.6957H17.064Z",
    fill: "url(#paint0_linear_339_2327)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_339_2327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 21,
    width: 38,
    height: 21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254_3",
    d: "M16.9813 41.9387C16.9813 38.0859 20.1047 34.9625 23.9575 34.9625H34.6987L33.6957 41.9387H16.9813Z",
    fill: "black",
    fillOpacity: 0.2,
    style: {
      fill: "black",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254_4",
    d: "M53.9579 34.9629C53.9579 38.8157 50.8346 41.9391 46.9817 41.9391H36.2406L37.2436 34.9629H53.9579Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254_5",
    d: "M35.1086 21.6255C38.9046 22.2849 41.4473 25.8967 40.7879 29.6927L38.9495 40.2754L32.2479 38.0932L35.1086 21.6255Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_339_2327)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3255",
    x: 16.2201,
    y: 16.2183,
    width: 45.4139,
    height: 44.3327,
    fill: "url(#paint1_linear_339_2327)",
    style: {}
  }))), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "M60.5497 30.3927C60.2137 32.4425 59.424 34.3243 58.1807 36.0381C56.9373 37.7182 55.2404 39.0792 53.0898 40.1209C50.9728 41.1626 48.4693 41.6834 45.5794 41.6834H40.2365L38.3922 52.2526L29.8609 51.7194L35.5993 19.0012H49.5614C53.2578 19.0012 56.0469 19.8245 57.9286 21.4711C59.8104 23.084 60.7513 25.285 60.7513 28.0741C60.7513 28.9142 60.6841 29.6871 60.5497 30.3927ZM46.0835 34.9292C49.3094 34.9292 51.208 33.417 51.7792 30.3927C51.8464 29.8551 51.88 29.4686 51.88 29.2334C51.88 28.1581 51.5272 27.3348 50.8215 26.7636C50.1495 26.1587 49.1078 25.8563 47.6964 25.8563H43.0088L41.4462 34.9292H46.0835Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254_6",
    d: "M58.3833 35.6078C55.5279 39.3793 51.0829 41.611 46.3525 41.6481L40.2368 41.696L41.4619 34.9244H58.9006L58.3833 35.6078Z",
    fill: "url(#paint2_linear_339_2327)",
    style: {}
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_2327",
    x1: 23.7903,
    y1: 38.3848,
    x2: 48.1192,
    y2: 35.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2064FA",
    style: {
      stopColor: "#2064FA",
      stopColor: "color(display-p3 0.1255 0.3922 0.9804)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_339_2327",
    x1: 38.9271,
    y1: 16.2183,
    x2: 38.9271,
    y2: 60.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2064FA",
    style: {
      stopColor: "#2064FA",
      stopColor: "color(display-p3 0.1255 0.3922 0.9804)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B37F5",
    style: {
      stopColor: "#3B37F5",
      stopColor: "color(display-p3 0.2314 0.2157 0.9608)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_339_2327",
    x1: 27.0327,
    y1: 37.8445,
    x2: 49.7397,
    y2: 34.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2064FA",
    style: {
      stopColor: "#2064FA",
      stopColor: "color(display-p3 0.1255 0.3922 0.9804)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.fa62308807581e0bc1c5563f88b5eee8.svg";
export { ForwardRef as ReactComponent };